
import { InjectedConnector } from "@web3-react/injected-connector";
import { networks } from "../config/networks";

const injected = new InjectedConnector({
  supportedChainIds: networks.map(net => parseInt(net.id,16))
});

export { injected };
